import React from "react";
import Header from '../../components/header'
import Footer from '../../components/footer'

import { ContactService } from "../../services/common/action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ThanksModel from "../common/Model/thanksModel";
import { onlyAlphabets } from "./keyValidation";

class Contact extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstName: "",
      lastName: "",
      emailAddress: "",
      reason: "",
      content: "",
      requestId:"",
      errors: {
        userName: "",
        emailAddress: "",
        content: "",
        reason: ""
      },
      emailValid: false,
      firstNameValid: false,
      lastNameValid: false,
      contentValid: false,
      reasonValid: false,
      openPopUp:false,

    }
 

  }

  handleChange = (e) => {
    const name = e.target.name
    const value = e.target.value
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  }


  validateField(fieldName, value) {
    const {
      errors,
      firstNameValid,
      lastNameValid,
      emailValid,
      contentValid,
      reasonValid
    } = this.state;

    let fieldValidationErrors = errors;
    let firstNamevalid = firstNameValid;
    let lastNamevalid = lastNameValid;
    let emailvalid = emailValid;
     let reasonvalid = reasonValid;


    switch (fieldName) {

      case "firstName":
      firstNamevalid = !(value.length < 3 || value.length > 20);
        fieldValidationErrors.fieldName = firstNamevalid
          ? ""
          : "Name should be 3 to 20 characters";
        break;
        case "lastName":
        lastNamevalid = !(value.length < 3 || value.length > 20);
          fieldValidationErrors.fieldName = lastNamevalid
            ? ""
            : "Name should be 3 to 20 characters";
          break;
      case "emailAddress":
        emailvalid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.emailAddress = emailvalid
          ? ""
          : " Please enter valid Email Address";
        break;
      case "reason":
        reasonvalid = !(value === "" || value ===null);
        fieldValidationErrors.reason = reasonvalid
          ? ""
          : "Please Select the Reason";
        break;
    
      default:
        break;
    }
    this.setState(
      {
        errors: fieldValidationErrors,
        firstNameValid: firstNamevalid,
        lastNameValid: lastNamevalid,
        emailValid: emailvalid,
         reasonValid: reasonvalid
      },
      this.validateForm
    );
  }

  gotoBack = (e) =>{
    e.preventDefault();
               this.props.history.goBack();   

  }

  validateForm() {
    const {
      firstNameValid,
      lastNameValid,
      emailValid,
       reasonValid
    } = this.state;

    this.setState({
      formValid:
      firstNameValid && lastNameValid &&
        emailValid &&   reasonValid
    });
  }


  ContactFormSubmit = (e) => {
    e.preventDefault();

    const {
      firstName,
      lastName,
      emailAddress,
      reason,
      content,
      requestId
    } = this.state;

    let payLoad = {
      "firstName": firstName,
      "lastName": lastName,
      "emailAddress": emailAddress,
      "reason": reason,
      "content": content,
      "requestId":requestId
    }
    this.props.ContactService(payLoad);

  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.contactStatus === true) {
      this.setState({
        openPopUp:true,
      })
      
    }

  };
  closePopUp = () => {
    this.setState({
      openPopUp: false
    })
this.props.history.push("/login");
}

  render() {
    const {
      errors,
      firstName,
      lastName,
      emailAddress,
      reason,
      content,
      formValid,
      requestId

    } = this.state
    return (
      <React.Fragment>

        <div className="registration-wrapper">
          <Header routes={[ { "name": "Contact", "route": "/Contact", }]} />

          <div className="register-content">
            <div className="container">
              <div className="form-head ">
                <h1>Contact Us</h1>
              </div>
              <div className="form-body">
                <form onSubmit={this.ContactFormSubmit}>

                  <div className="row">

                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 contact-img">
                    
                      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2586.6643740637287!2d-74.0100178!3d40.7069493!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2bfe945607c07%3A0x2da6ae4660278476!2sFerndale+Road!5e1!3m2!1sen!2sin!4v1554287133695!5m2!1sen!2sin" width="100%" height="100%" title="maps" frameBorder='0'></iframe>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                      <div className="form-group r-form">
                        <label for="fname">First Name</label><sup>*</sup>

                        <input type="text" className="form-control r-txt" id="fname" placeholder="First Name" value={firstName} name="firstName" onKeyPress = {onlyAlphabets} onChange={this.handleChange}/>
                        <div className="r-icon">
                          <i className="fa fa-user" aria-hidden="true"></i>
                        </div>
                        <div style={{ color: "red" }}>{errors.firstName}</div>

                      </div>
                      <div className="form-group r-form">
                        <label for="lname">Last Name</label><sup>*</sup>
                        <input type="text" className="form-control r-txt"  value={lastName} placeholder="Last Name" name="lastName" onChange={this.handleChange}/>
                        <div className="r-icon">
                          <i className="fa fa-user" aria-hidden="true"></i>
                        </div>
                        <div style={{ color: "red" }}>{errors.lastName}</div>
                      </div>

                      <div className="form-group r-form">
                        <label for="email">Email</label><sup>*</sup>
                        <input type="text"  className="form-control r-txt" id="email" name="emailAddress" value={emailAddress}  placeholder="Email Address" onChange={this.handleChange} />
                        <div className="r-icon">
                          <i className="fa fa-envelope" aria-hidden="true"></i>
                        </div>
                        
                      </div>
                      <div style={{ color: "red" }}>{errors.emailAddress}</div>

                      <div className="form-group r-form">
                          <label for="reqId">Request ID</label>
                          <input type="text" className="form-control r-txt" name="requestId" value={requestId} placeholder="Request ID" onChange={this.handleChange} />
                          

                      </div>
                             

                      <div className="form-group r-form">

                        <label for="state">Please select the reason for your inquiry</label><sup>*</sup>
                        <select className="form-control" id="state"   name="reason" value={reason} onChange={this.handleChange}  >
                          <option value="">Please select the reason for your inquiry</option>
                          <option >General Support</option>
                          <option>Records Not Received</option>
                          <option>Billing Issue</option>
                          <option>Regulatory Inquiry</option>
                          <option>Software Demonstration</option>
                          <option>Website Suggestions</option>
                        </select>
                      </div>
                      <div style={{ color: "red" }}>{errors.reason}</div>
                      <div className="form-group r-form">
                        <label for="address1">Tell us a little about what you are looking for?</label>

                        <textarea  className="form-control r-txt-area" rows="4" id="address1" name="content" value={content}
                          onChange={this.handleChange} placeholder="Message(Optional)"></textarea>
                       </div>
                    </div>

                  </div>

                  <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12"></div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <button  onClick={this.gotoBack} className="btn cancel-btn">Back</button>
                      <div className="button-right">
                        
                        <button type="submit"  disabled={ !formValid} className="btn submit-btn">Submit</button>
                      </div>
                    </div></div>


                </form>

              </div>

 
            </div>
            <div style={{textAlign:"center",     marginTop: "42px"}}>
            <a id="bookafy-scheduling" href="https://ferndaleroad.bookafy.com/schedule/?type=iframe&custom_embed=true&selected_staff=kenneth-levey&locale=en" class="custom_button btn-simple active"
             style= {{textAlign: "center",   cursor: "pointer", border:  "2px solid rgb(255, 255, 255)",  width: "545px", maxHeight: "100px", padding: "14px 16px", backgroundColor: "rgb(38, 55, 170)", alignSelf: "center", color: "rgb(255, 255, 255)", fontSize: "15px", fontWeight: "bold", textDecoration: "none", visibility: "visible", borderRadius: "2px"}}
              alt="Booknow button" target="_blank"  >Book Software Demonstration Now</a>
            </div>
          </div>

          {/* <!-- Footer Section --> */}
          <Footer />
        </div>


        

<ThanksModel header="Contact"  page="contact" text="Thank you for your inquiry. A member of our team will follow up in 24 hours" status={this.state.openPopUp}   confirmOkay={this.closePopUp}/>



      </React.Fragment>
    )
  }

}
const mapStateToProps = state => ({
  message: state.commonReducer.message,
  contactStatus: state.commonReducer.contactStatus,
  //isLoading: state.commonReducer.isLoading
});

const mapDispatchToProps = dispatch => ({
  ContactService: payLoad => dispatch(ContactService(payLoad))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Contact));
